import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import { SharedService } from "./../../shared/shared.service";
import { DevoteeService } from './../devotee.service';
import { DevoteeDetail } from './../devotee-detail';

@Component({
  selector: 'devotee-registation',
  templateUrl: './devotee-registation.component.html',
  styleUrls: ['./devotee-registation.component.css', './../devotee-profile/devotee-profile.component.css']
})
export class DevoteeRegistationComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private devoteeService: DevoteeService,
    private sharedService: SharedService) { }

  devoteeForm: FormGroup;
  stateList: string[] = [];
  savedMessage: string = "";
  errorMessage: string = "";

  ngOnInit() {
    this.createAddDevoteeForm();
    this.stateList = this.sharedService.StateLists;
  }


  saveForm(): void {
    let devoteeDetail: DevoteeDetail = this.devoteeForm.value;

    if (this.devoteeForm.invalid) {
      this.sharedService.validateAllFormFields(this.devoteeForm);
      console.log(this.devoteeForm.errors);
      return;
    }

    if (!this.devoteeForm.controls.Declaration.value) {
      return;
    }

    // Save Devotee
    console.log(devoteeDetail);
    this.sharedService.showSpinner();
    this.devoteeService.saveDevotee(devoteeDetail).subscribe(
      data => {
        this.devoteeForm.markAsPristine();
        this.savedMessage = data;
        this.sharedService.setDevoteeDataAtLocStorage(devoteeDetail);
        this.router.navigate(["/login"]);
        console.log(data);
      },
      err => {
        this.errorMessage = err.error.Message;
        console.log(this.errorMessage);
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  createAddDevoteeForm(): void {
    this.devoteeForm = this.formBuilder.group({
      Id: [0],
      FirstName: ["", Validators.required],
      MiddleName: [""],
      LastName: ["", Validators.required],
      AddressLine1: [, Validators.maxLength(28)],
      AddressLine2: [, Validators.maxLength(28)],
      AddressLine3: [, Validators.maxLength(28)],
      AddressLine4: [, Validators.maxLength(28)],
      City: [, Validators.required],
      State: ["", Validators.required],
      PinCode: [, [Validators.required, Validators.max(999999)]],
      MobileNo: [, Validators.required],
      Email: [],
      Declaration: [, Validators.required]
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/devotee/devotee-registation/devotee-registation.component.ts